import api from "./httpService";

const toArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") {
        const data = value as { data?: unknown; items?: unknown; products?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.products)) return data.products;
    }
    return [];
};

export const getStockService = async () => {
    const response = await api.get("/stock");
    return toArray(response.data);
};

export const addStockService = async (payload: FormData) => {
    const response = await api.post("/stock", payload, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};
